<template>
  <section>
    <el-col :span="6" class="toolbar">
      <el-input placeholder="" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading"
              @expand="expand"
              :row-key="getRowKeys"
              :expand-row-keys="expands">
      <el-table-column type="expand">
        <template scope="scope">
          <el-table :data="tableComment">
            <el-table-column
              label="用户名称"
              prop="username"
              align="center">
            </el-table-column>
            <el-table-column
              label="点赞次数"
              prop="zan"
              align="center">
            </el-table-column>
            <el-table-column
              label="评论内容"
              prop="evacontent"
              align="center">
            </el-table-column>
            <el-table-column
              label="创建时间"
              prop="createtime"
              align="center">
            </el-table-column>
            <el-table-column
              label="操作"
              align="center">
              <template scope="scope">
                <el-button :plain="true" type="info" size="small" @click="deleteData1(scope.row._id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="0" class="toolbar_page">
            <el-pagination
              @size-change="handleSizeChangeComment"
              @current-change="handleCurrentComment"
              :page-sizes="[10, 15, 20, 30]"
              :page-size="pageSizeComment"
              layout="sizes, prev, pager, next"
              :total="totalComment">
            </el-pagination>
          </el-col>
        </template>
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="proname"
        align="center">
      </el-table-column>
      <el-table-column
        label="用户名称"
        prop="username"
        align="center">
      </el-table-column>
      <el-table-column
        label="订单编号"
        prop="ordernum"
        align="center">
      </el-table-column>
      <el-table-column
        label="评价内容"
        prop="evacontent"
        align="center">
      </el-table-column>
      <el-table-column
        label="回复评价内容"
        prop="revacontent"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createtime"
        align="center">
      </el-table-column>
      <el-table-column
        label="浏览次数"
        prop="viewcount"
        align="center">
      </el-table-column>
      <el-table-column
        label="推荐状态"
        prop="isrecommend"
        align="center">
        <template scope="scope">
          <div>{{recommend[scope.row.isrecommend]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="审核状态"
        prop="isverify"
        align="center">
        <template scope="scope">
          <div>{{verify[scope.row.isverify]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="记录状态"
        align="center">
        <template scope="scope">
          <div>{{status[scope.row.status]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center">
        <template scope="scope">
          <el-button v-if="scope.row.isverify == 0" :plain="true" type="info" size="small" @click="setVerify(scope.row._id)">审核</el-button>
          <el-button v-if="scope.row.isrecommend == 0" :plain="true" type="info" size="small" @click="setRecommend(scope.row._id, 1)">推荐</el-button>
          <el-button v-else :plain="true" type="info" size="small" @click="setRecommend(scope.row._id, 0)">取消推荐</el-button>
          <el-button v-if="scope.row.pic" :plain="true" type="info" size="small" @click="getPicUrl(scope.row)">查看图片</el-button>
          <el-button :plain="true" type="info" size="small" @click="replyComment(scope.row)">回复评论</el-button>
          <el-button :plain="true" type="danger" size="small" @click="deleteData(scope.row._id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <el-dialog title="查看图片" v-model="picVisible">
      <div class="piclist">
        <a v-for="(pic, index) in picList" :key="index" target="_blank" :href="pic"><img :src="pic" /></a>
      </div>
    </el-dialog>

    <el-dialog title="回复评论" v-model="replyVisible">
      <el-row>
        <el-col :span="4">
          回复评论：
        </el-col>
        <el-col :span="16">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="revacontent">
          </el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="revacontentSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        expands: [],
        getRowKeys(row) {
          return row._id;
        },
        query: '',
        usid: 0,
        proid: 0,
        recommend: basicdata.recommend,
        verify: basicdata.verify,
        status: basicdata.status,
        picVisible: false,
        picList: [],
        tableComment: [],
        totalComment:0,
        pageComment:1,
        pageSizeComment:5,
        commentId: '',
        replyVisible: false,
        revacontent: '',
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        let url = config.api_url + '/comment/page/' + this.proid + '/' + this.usid
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
  		//操作删除
  		deleteData(id){
        if(id !=0){
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/comment/delete/' + id
          ).then(response => {
              if(response.data.state) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error)
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //审核
      setVerify(id) {
        this.$axios.post(config.api_url + '/comment/verify', {
          id: id,
          status: 1
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '审核成功!',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              message: '推荐失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '审核异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //推荐
      setRecommend(id, isrecommend) {
        this.$axios.post(config.api_url + '/comment/recommend', {
          id: id,
          status: isrecommend
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '推荐成功!',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              message: '推荐失败，请联系管理员',
              type: 'error'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '推荐异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //查看图片
      getPicUrl(row) {
        this.picVisible = true;
        this.picList = row.pic.split(',');
      },
      //分页方法
      handleSizeChangeComment(size) {
        this.pageSizeComment = size;
        this.getVisitComment();
      },
      handleCurrentChangeComment(page) {
        this.pageComment = page;
        this.getVisitComment();
      },
      //查询游客评论
      expand(row, expanded) {
        if(expanded) {
          this.commentId = row._id;
          this.getVisitComment();
          this.expands = [];
          this.expands.push(row._id);
        }
      },
      getVisitComment() {
        this.$axios.post(config.api_url + '/visitcomment/page', {
          "page": this.pageComment,
          "size": this.pageSizeComment,
          "query": this.commentId
        }).then(response => {
          if(response.data.state) {
            this.tableComment = response.data.msg;
          } else {
            this.$message({
              message: '查询游客评论失败，请联系管理员',
              type: 'error'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '查询游客评论异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //操作删除
  		deleteData1(id){
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.delete(config.api_url + '/visitcomment/delete/' + id
        ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getVisitComment();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      replyComment(row) {
        this.replyVisible = true;
        this.revacontent = row.revacontent;
        this.commentId = row._id;
      },
      revacontentSubmit() {
        this.$axios.post(config.api_url + '/comment/revacontent',{
          id: this.commentId,
          revacontent: this.revacontent
        }).then(response => {
          if(response.data.state) {
             this.$message({
              message: '回复评论成功!',
              type: 'success'
            });
            this.replyVisible = false;
            this.search();
          } else {
            this.$message({
              message: '回复评论失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
            console.log(error)
            this.$message({
              message: '回复评论异常，请联系管理员',
              type: 'error'
            });
        });
      }
    },
    created() {
      this.usid = parseInt(this.$route.params.usid);
      this.proid = parseInt(this.$route.params.proid);
      this.search();
    }
  }
</script>

<style scoped>
    .rightsearch{
        float: right;
    }
    .piclist {
      width: 100%;
    }
    .piclist>a {
      width: 30%;
      float: left;
      padding: 0 10px 10px 10px;
    }
    .piclist>a>img {
     width: 100%;
     height: 100px;
    }
</style>


// WEBPACK FOOTER //
// Comment.vue?2c7953e8